import { BACKEND_PRIVATE } from '@/api/base'

export async function doneGig(id: LX.GigJob['id']) {
  return BACKEND_PRIVATE.post(`/me/gigs/jobs/mark-done?id=${id}`)
}

export async function cancelDoneGig(id: LX.GigJob['id']) {
  return BACKEND_PRIVATE.post(`/me/gigs/jobs/mark-not-done?id=${id}`)
}
